export default {
  tracking: {
    en: 'Tracking',
  },
  subscriptionStatus: {
    en: 'Subscription status',
  },
  resubscribe: {
    en: 'Resubscribe',
  },
  unpause: {
    en: 'Unpause',
  },
  upgradeYourPlan: {
    en: 'Upgrade your plan',
  },
  prepaidPlans: {
    en: 'Prepay and save',
  },
  myOrders: {
    en: 'My orders',
  },
  personalInfo: {
    en: 'Personal info',
  },
  billingAndShipping: {
    en: 'Billing & Shipping',
  },
  giftSent: {
    en: 'Gift sent',
  },
  changePassword: {
    en: 'Change password',
  },
  referAFriend: {
    en: 'Refer a friend',
  },
  logout: {
    en: 'Logout',
  },
}
